import Vue from 'vue'
import { Component } from 'vue-property-decorator';
import DocumentViewer from "@/components/common/Modal/DocumentViewer.vue";
@Component({
    components: {
        DocumentViewer
    }
})
export default class BaseLayout extends Vue {
    logoutLoad() {
        let iframe = document.getElementById('iframe_logout') as HTMLIFrameElement
        if (iframe.src.indexOf('adfs') > -1)
            this.$router.push({ name: 'login' })
    }
}